import 'rxjs';
import { combineEpics } from 'redux-observable';

import stickers from './stickers';
import { newTextEpic, copyEpic } from "./objectsEpic";

export default combineEpics(
  stickers,
  newTextEpic,
  copyEpic
);


// WEBPACK FOOTER //
// ./src/epics/index.js